
import { Checkbox } from '05-ui-kit';
import type SortType from '~/type/Sort';
interface Props {
  list: SortType[];
  availability: boolean;
  value: SortType;
}
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  availability: {
    key: "availability",
    required: false,
    type: Boolean,
    default: false
  },
  value: {
    key: "value",
    required: true,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  function onSort(el: SortType) {
    /**
    * Срабатывает при выборе пункта сортировки
    */
    emit('sort', el);
  }
  function onAvailabilityChange(val: string) {
    /**
    * Срабатывает при нажатии на чекбокс
    */
    emit('availability-change', val);
  }
  return {
    onSort,
    onAvailabilityChange
  };
};
__sfc_main.components = Object.assign({
  Checkbox
}, __sfc_main.components);
export default __sfc_main;
